<div class="container-fluid header d-border-bottom">

    <div class="p-0 pl-2">

        <div class="db-box-shadow">
            <img class="img-fluid w-100 mt-2" src="/assets/images/delaware-logo.png" alt="delaware-logo"/>
        </div>
    </div>
    
</div>